/**
 * Maximum allowed capture amount as a percentage above the authorized amount.
 * This provides tolerance for tips, taxes, or other minor adjustments.
 * For example, 1.15 means 15% above the authorized amount.
 */
export const CAPTURE_TOLERANCE_MULTIPLIER = 1.15;

/**
 * The percentage value of the capture tolerance (for display purposes).
 * This is the decimal representation: 15 means 15%.
 */
export const CAPTURE_TOLERANCE_PERCENT = 15;

/**
 * Minimum total capture amount accepted by the payment gateway.
 * Captures must be strictly greater than this value.
 */
export const MIN_CAPTURE_AMOUNT = 0.5;
